import { set, toggle } from '@/utils/vuex'

export default {
  setDownloading: set('downloading'),
  setByteDownloaded: set('byteDownloaded'),
  setTotalByte: set('totalByte'),
}